import {
  teamsDarkTheme,
  teamsHighContrastTheme,
  teamsLightTheme,
} from '@fluentui/react-components';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Theme, ThemePreference } from './abstractions';

export const themeSlice = createSlice({
  name: 'themes',
  initialState: {
    systemTheme: 'light' as Theme,
    preferredTheme: 'default' as ThemePreference,
  },
  reducers: {
    systemThemeChanged: (state, action: PayloadAction<Theme>) => {
      state.systemTheme = action.payload;
    },
    preferredThemeChanged: (state, action: PayloadAction<ThemePreference>) => {
      state.preferredTheme = action.payload;
    },
  },
  selectors: {
    getThemePreference: (state) => state.preferredTheme,
    getCurrentTheme: (state) => {
      return state.preferredTheme === 'default'
        ? state.systemTheme
        : state.preferredTheme;
    },
    getFluentTheme: (state) => {
      const currentTheme =
        state.preferredTheme === 'default'
          ? state.systemTheme
          : state.preferredTheme;
      switch (currentTheme) {
        case 'dark':
          return teamsDarkTheme;
        case 'contrast':
          return teamsHighContrastTheme;
        case 'light':
        default:
          return teamsLightTheme;
      }
    },
  },
});
